// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ShareOutlineSvg from '@rsuite/icon-font/lib/action/ShareOutline';
var ShareOutline = createSvgIcon({
  as: ShareOutlineSvg,
  ariaLabel: 'share outline',
  category: 'action',
  displayName: 'ShareOutline'
});
export default ShareOutline;